"use client";

/**
 * 카미봇 프리미엄/멤버십 페이지 (/premium)
 *
 * 별도 라우트. 메인 페이지(`/`)와는 분리된 진입점.
 * 디자인 핸드오프(`.design-handoff/premium.*`)를 Next.js 16 + React 19로 이식.
 *
 * 컴포넌트 순서: PremiumNav → PremiumHero → #plans → PremiumPlans → PremiumCosts
 *               → PremiumCompare → PremiumLetter → PremiumFAQ → footer
 *
 * 메인 페이지처럼 `.kamibot-v2` 컨테이너 안에 토큰을 격리.
 * 추가로 `.prem-app` 변형 클래스를 얹어 프리미엄 페이지 전용 배경/스타일을 적용.
 */

import Link from "next/link";
import { useTheme } from "next-themes";

import { PremiumNav } from "@/components/kamibot-v2/sections/premium/PremiumNav";
import { PremiumHero } from "@/components/kamibot-v2/sections/premium/PremiumHero";
import { PremiumPlans } from "@/components/kamibot-v2/sections/premium/PremiumPlans";
import { PremiumCosts } from "@/components/kamibot-v2/sections/premium/PremiumCosts";
import { PremiumCompare } from "@/components/kamibot-v2/sections/premium/PremiumCompare";
import { PremiumLetter } from "@/components/kamibot-v2/sections/premium/PremiumLetter";
import { PremiumFAQ } from "@/components/kamibot-v2/sections/premium/PremiumFAQ";

export default function PremiumPage() {
  const { resolvedTheme, setTheme } = useTheme();
  const theme: "light" | "dark" = resolvedTheme === "dark" ? "dark" : "light";

  return (
    <div className="kamibot-v2 prem-app">
      <PremiumNav theme={theme} setTheme={(t) => setTheme(t)} />
      <PremiumHero />
      <div id="plans" />
      <PremiumPlans />
      <PremiumCosts />
      <PremiumCompare />
      <PremiumLetter />
      <PremiumFAQ />
      <footer className="foot prem-foot">
        <div className="shell">
          <div className="foot-bottom">
            <span>© 2026 카미봇 · made with ♡ in Seoul</span>
            <span>
              <Link href="/">← 메인으로</Link>
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}
